import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ProductCardQuickAdd extends ThemeComponent {
    init() {
        this.listenForOuterDrawerClick();
    }

    public listenForOuterDrawerClick() {
        this.$listen(this, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement === this) {
                    this.classList.remove('product-quick-add--active');
                }
            }
        });
    }
}
